import { useModuleBEM } from "@b2bportal/core-themes";
import { useI18nContext } from "@hopper-b2b/i18n";
import { getFlyerOptionFromValue } from "../../../../utils";
import styles from "./styles.module.scss";

interface FrequentFlyerRowProps {
  frequentFlyerNumber: string;
  frequentFlyerProgramName: string;
  onRemove?: () => void;
}

export const FrequentFlyerRow: React.FC<FrequentFlyerRowProps> = ({
  onRemove,
  frequentFlyerNumber,
  frequentFlyerProgramName,
}) => {
  const [block, cn] = useModuleBEM(styles, "FrequentFlyerRow");
  const { t } = useI18nContext();

  const { airline, program } =
    getFlyerOptionFromValue(frequentFlyerProgramName) || {};

  if (!airline || !program) {
    return null;
  }

  return (
    <div className={block}>
      <div className={cn("frequent-flyer-details")}>
        <span className={cn("program-name")}>{`${airline} - ${program}`}</span>
        <span className={cn("number")}>{`***${frequentFlyerNumber.slice(
          -4
        )}`}</span>
      </div>
      <div className={cn("frequent-flyer-actions")}>
        {onRemove && <button onClick={onRemove}>{t("delete")}</button>}
      </div>
    </div>
  );
};
